import img1 from "../img/img1.png";
import img2 from "../img/img2.png";
import img3 from "../img/img3.png";
import img4 from "../img/img4.jpg";

export const Followers = [
  { name: "Andrev Thomas", username: "Thomas", img: img1 },
  { name: "Hulk Buster", username: "Hulk", img: img2 },
  { name: "Thunder Master", username: "Thur", img: img3 },
  { name: "Natasha Dariovski", username: "Natasha", img: img4 },
];
